export default __webpack_public_path__ + "static/media/Supplier_Product_Promotion_2407_0608_2025.ab7b5027.xlsx";